
















































































































































































































import Vue from 'vue';

export default Vue.extend({
  props: {
    recibosInit: Array,
    saldoDisponible: Object,
    disabled: Boolean,
  },
  data: () => ({
    ingreso: {
      fecha:  '',
      monto:  '',
      ref:    '',
      cuenta: {},
      unidad: {},
    },
    dialog: false,
    cobrosDialog: false,
    loading: false,
    colspan: 3,
    // conceptos: [],
    nuevoItem: {},
    // conceptosFiltro: [],
    filtro: {},
    headers: [
      { text: 'Concepto', value: 'concepto.nombre'},
      { text: 'Estatus', value: 'pagoStatus'},
      { text: 'ADEUDO', value: 'openTotal'},
      { text: 'Cobro', value: 'monto'},
    ],
    recibosTabla: [],
    selectedItems: [],
    recibo: [],
    precision: 2,
    // selectedConcepto: '',
    cobro: {
      monto: '',
      fecha: '',
      referencia: '',
      metodoDePago: '',
      cuenta: {},
      items: [],
    },
    items: [],
    totalRecibo: 0,
    totalCobro: 0,
    isEqual: true,
    selected: [],
    cobros: ['Efectivo', 'Cheque', 'Transferencia'],
    menu: false,
    dateCobro: '',
    formatoFecha: 'DD/MM/YYYY',
    cuentasBancarias: [],
    options: {page: 1, itemsPerPage: 100000, sortBy: 0},
    saldo: 0,
    // saldoUnidad: 0,
    // saldoAFavor: false,
    pagoSaldo: false,
    unidad: {},
    ref: '',
    ingresoNoRec: false,
  }),
  mounted() {
    // this.dateCobro = this.$moment().format();
  },
  computed: {
    computedDateFormatted() {
      if (this.dateCobro === '') {
        return this.dateCobro;
      } else {
        return  this.$moment(this.dateCobro).format(this.formatoFecha);
      }
    },
  },
  methods: {
    async clickCobroButton() {
      try {
        console.log('recibo: ', this.recibosInit[0].id);
        const admin = this.$store.getters.getAdmin.id;
        const condo = this.$store.getters.getCondo.id;
        const reciboSeleccionado = this.recibosInit[0].id;
        const result = await this.$store.dispatch('getStatusRecibo', {admin, condo, reciboId: reciboSeleccionado});
        this.unidad = this.recibosInit[0].unidad;
        this.$refs.cobroActivator.$el.click();
      } catch (e) {
        this.$toast.error(e.response.data.message);
        console.error(e.response.data.message);
      }
    },

    compareToMonto(value) {
      // if (this.pagoSaldo) {
      //   return this.compareToSaldo(value);
      // }
      if (value > this.totalRecibo) {
        return 'valor invalido';
      }
      return true;
    },
    // compareToSaldo(value) {
    //   if (this.totalRecibo < (this.saldoUnidad * -1)) {
    //     if (value > this.totalRecibo) {
    //       return 'valor invalido';
    //     }
    //   } else {
    //     if (value > (this.saldoUnidad * -1)) {
    //       return 'monto superior al saldo a favor';
    //     }
    //   }
    //   return true;
    // },
    async loadData() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const result = await this.$store.dispatch('getCuentasList', {admin, condo, options: this.options});
      // this.cuentasBancarias = result.content;
      this.cuentasBancarias = result;
      // console.debug('CuentasResult %o', this.cuentasBancarias);
    },
    async findRecibo(recibo) {
      // console.log('find Recibo %o', recibo);
      const admin = this.$store.getters.getAdmin.id;
      const condo = this.$store.getters.getCondo.id;
      const reciboId = recibo;
      const datos = {admin, condo, reciboId};
      const response = await this.$store.dispatch('findReciboId', {datos});
      // console.log('recibo: ', response.data);
      this.items = response.data.items;
      this.totalRecibo = response.data.openTotal;
      this.addMontoItems(this.items);
      this.updateTotalCobro();
      // console.log("Items: ",this.items);
    },
    addMontoItems(items) {
      const monto = 'monto';
      for (const item of items) {
        item[monto] = Number(0);
      }
    },
    async generarIngreso() {
      if (this.totalRecibo < this.cobro.monto) {
        this.dialog = true;
        this.ingreso = {
          fecha:  this.$moment(this.dateCobro).format(),
          monto:  this.cobro.monto - this.totalCobro,
          ref:    'Ingreso restante Cobro',
          cuenta: this.cobro.cuenta,
          unidad: this.unidad,
        };
        console.debug('Ingreso: ', this.ingreso);
      } else {
        this.newCobro(false);
      }
    },
    // async nIngNoReconocido() {
    //   const admin = this.$store.getters.getAdmin;
    //   const condo = this.$store.getters.getCondo;
    //   const result = await this.$store.dispatch('addIngreso', {admin, condo, ingreso: this.ingreso});
    //   console.debug('IngresoNoReconocido: ', result);
    //   this.dialog = false;
    //   // this.newCobro(true);
    // },
    validateNewCobro() {
      const validacion = this.validateItemsMonto();
      const ingNo = Boolean(0 < (this.cobro.monto - this.totalRecibo));
      if (validacion.error) {
        this.$toast.error(`El valor del campo cobro no puede ser mayor al adeudo del concepto: ${validacion.nombre}`);
        return;
      }
      if (this.saldo !== 0 && this.saldo < this.cobro.monto) {
        this.$toast.error(`el valor del monto es mayor al saldo disponible`);
        return;
      }
      // console.debug('CAMPOS_VACIOS: '
      //   , !(this.cobro.monto && this.dateCobro
      //     && this.cobro.metodoDePago && Object.keys(this.cobro.cuenta).length !== 0
      //     && this.totalCobro !== 0));
      if (!(this.cobro.monto && this.dateCobro
          && this.cobro.metodoDePago && Object.keys(this.cobro.cuenta).length !== 0
          && this.totalCobro !== 0)) {
        this.$toast.error('Campos vacios');
        return;
      }
      if (Number(this.cobro.monto) >= Number(this.totalCobro)) {
        if (!((this.recibo[0].openTotal >= this.cobro.monto) || ingNo)) {
          this.$toast.error('Monto maximo aceptado: $' + this.recibo[0].openTotal);
          return;
        } else {
          // this.$toast.success('Success');
          this.generarIngreso();
        }
      } else {
        this.$toast.error('El monto es menor al Total ingresado.');
        return;
      }
    },
    async newCobro(ingNo) {
          try {
            this.cobro.fecha = this.$moment(this.dateCobro).format();
            this.cambioOpentotal(this.items);
            this.cobro.items = this.items;
            this.cobro.ingresoNoRec = this.ingresoNoRec;
            this.cobro.ingresoId = this.ingresoId;
            const admin = this.$store.getters.getAdmin;
            const condo = this.$store.getters.getCondo;
            const recibo = this.recibo[0];
            const cobro = this.cobro;
            // const item = this.selected[0].concepto;
            // console.debug('Cobro-Enviado: ', cobro);
            const datos = {admin, condo, recibo, cobro};
            // console.debug('addCobrItem enviado %o', datos);
            if (this.saldo !== 0) {
              const response = await this.$store.dispatch('addCobroItemSaldo', {datos});
              // console.log('Pago con saldo');
            } else {
              if (this.ingreso.monto !== '') {
                const cobroIng = {...this.cobro, ingreso: this.ingreso};
                const datosIngreso = {admin, condo, recibo, cobro: cobroIng};
                console.debug('ingreso-1: ', datosIngreso);
                const response = await this.$store.dispatch('addCobroItem', {datosIngreso});
                console.debug('RESPONSE: ', response);
              } else {
                const datosIngreso = {admin, condo, recibo, cobro: this.cobro};
                console.debug('ingreso-2: ', datosIngreso);
                const response = await this.$store.dispatch('addCobroItem', {datosIngreso});
                console.debug('RESPONSE: ', response);
              }
              // console.log(response);
              // this.nIngNoReconocido();
            }
            // console.debug('addCobro response: %o', response);
            this.$toast.success('Cobro agregado exitosamente');
            this.ingreso = this.cleanIngNoRec();
            this.closeDialog();
            this.cobro = {};
            console.debug('this.ingreso: ', this.ingreso);
            console.debug('this.Cobro: ', this.cobro);
          } catch (e) {
            console.error(e.message);
            // this.$toast.error(e.response.data.message);
          }
    },
    cleanIngNoRec() {
      return {
        fecha:  '',
        monto:  '',
        ref:    '',
        cuenta: {},
        unidad: {},
      };
    },
    validateItemsMonto() {
      const obj = {
        nombre: '',
        error: false,
      };
      for (const item of this.items) {
        if (item.monto > item.openTotal) {
          obj.error = true;
          obj.nombre = item.concepto.nombre;
          break;
        }
      }
      return obj;
    },
    cambioOpentotal(items) {
      for (const item of items) {
        item.openTotal = item.monto;
      }
      this.cobro.monto = 0;
      for (const item of items) {
        console.debug('mod');
        this.cobro.monto = Number(this.cobro.monto) + Number(item.openTotal);
      }
      console.debug('Cobro-MontoActual', this.cobro.monto);
    },
    closeDialog() {
      this.cobro = {monto: '', fecha: '', referencia: '', metodoDePago: '', cuenta: {}};
      this.dateCobro = '';
      this.$emit('reload', {});
      this.cobrosDialog = false;
    },
    modeloReciboTabla() {
      return {
        key: '',
        id: 0,
        administracion: {},
        condominio: {},
        propietario: {},
        unidad: {},
        item: {},
      };
    },
    modeloNuevoItem() {
      return {
        concepto: {},
        descripcion: '',
        unidadDeMedida: '',
        cantidad: '',
        unitario: '',
        importe: 0,
      };
    },
    restrictChars($event, e) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode)) || ($event.charCode === 46) && (e.indexOf('.') === -1))   {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    updateTotalCobro() {
      let total = 0;
      for (const item of this.items) {
        total += Number(item.monto);
      }
      const totalRedondeado = total.toFixed(this.precision);
      if (Number(totalRedondeado) === Number(this.cobro.monto)) {
        this.isEqual = false;
      } else {
        this.isEqual = true;
      }
      this.totalCobro = totalRedondeado;
    },
  },
  watch: {
    cobrosDialog() {
      if (this.cobrosDialog) {
        this.recibo = this.recibosInit;
        // console.log('recibo: %o', this.recibo);
        this.findRecibo(this.recibo[0].id);
        this.total = this.recibo.length;
        if (this.saldoDisponible != null) {
          this.unidad = this.recibo[0].unidad;
          // console.log('unidad: ', this.unidad);
          this.ingresoNoRec = true;
          this.ref = this.saldoDisponible.ref;
          this.saldo = this.saldoDisponible.openTotal;
          this.ingresoId = this.saldoDisponible.id;
        }
        this.loadData();
      } else {
        this.recibo = [];
      }
    },
  },
});
